import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useJamaah } from "@/context/JamaahContext";
import { errMsg } from "@/lib/api";
import { JamaahFields, Field } from "./JamaahFields";

const INITIAL = { name: "", gender: "L", rt: "05", rw: "06", phone: "", address: "", notes: "", password: "", confirm: "" };

export const RegisterForm = () => {
  const { register } = useJamaah();
  const navigate = useNavigate();
  const [form, setForm] = useState(INITIAL);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) return setError("Kata sandi minimal 6 karakter");
    if (form.password !== form.confirm) return setError("Konfirmasi kata sandi tidak sama");
    setLoading(true);
    try {
      const { confirm, ...payload } = form;
      await register(payload);
      navigate("/portal");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="register-form">
      <JamaahFields form={form} set={set} prefix="register" />
      <div className="grid sm:grid-cols-2 gap-3">
        <Field id="register-password" label="Kata Sandi" required>
          <Input id="register-password" type="password" value={form.password} onChange={(e) => set("password", e.target.value)} required placeholder="Min. 6 karakter" data-testid="register-password-input" />
        </Field>
        <Field id="register-confirm" label="Konfirmasi Kata Sandi" required>
          <Input id="register-confirm" type="password" value={form.confirm} onChange={(e) => set("confirm", e.target.value)} required data-testid="register-confirm-input" />
        </Field>
      </div>
      {error && <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="register-error">{error}</p>}
      <Button type="submit" className="w-full rounded-full h-11 emerald-bg hover:bg-[#145c48]" disabled={loading} data-testid="register-submit-btn">
        {loading ? <Loader2 className="animate-spin" size={18} /> : "Daftar & Masuk"}
      </Button>
    </form>
  );
};
